module.exports = __webpack_public_path__ + "img/meme_09.95a3d655.jpg";